import { Card, CardHeader, List } from '@material-ui/core';
import React, { Component } from 'react';
import { getCurrentFunctionName } from '../../performanceModeManager';
import InvoiceListDetail from './InvoiceListDetail';

class InvoicesAsCards extends Component {

    render() {
        console.perfLog(getCurrentFunctionName());

        let details = [];

        if (this.props.filteredAndSortedInvoices.length <= 0)
            return (
                <Card className="card">
                    <CardHeader title={"Aucun résultat"} className="text-center" titleTypographyProps={{ variant: "h6", color: 'primary' }} />
                </Card>
            );

        this.props.filteredAndSortedInvoices
            .filter((i) => !i.deleted)
            .forEach((i) => {
                details.push(
                    <InvoiceListDetail
                        globalContainer={this.props.globalContainer}
                        className="invoice-list-detail"
                        key={i.number}
                        invoice={i}
                    />
                );
            });

        return <List className="row">{details.map((d) => d)}</List>;
    }
}

export default InvoicesAsCards;
